(() => {
  if (window.__lp017Initialized) return;
  window.__lp017Initialized = true;

  const selector = '[data-lp017-order]';

  function nativeReleasitButton() {
    return document.querySelector(
      '#_rsi-buy-now-button._rsi-buy-now-button-product, #_rsi-buy-now-button-overwrite._rsi-buy-now-button-product, [data-rsi-buy-now], ._rsi-buy-now-button-product'
    );
  }

  function ensureReleasitButton() {
    let button = nativeReleasitButton();
    if (button) return button;

    const releasitProductPage = window._rsi && window._rsi.productPage;
    if (releasitProductPage && typeof releasitProductPage.initFeatures === 'function') {
      try {
        releasitProductPage.initFeatures();
      } catch (error) {
        console.warn('LP017: Releasit initialization deferred.', error);
      }
      button = nativeReleasitButton();
    }
    return button;
  }

  function syncJudgeMeRating() {
    const host = document.querySelector('[data-lp017-rating]');
    if (!host) return false;

    const source = [...document.querySelectorAll('.jdgm-preview-badge')]
      .find(badge => !badge.closest('[data-lp017-rating]'));
    if (!source || !source.classList.contains('jdgm--done-setup')) return false;

    const badge = source.querySelector('.jdgm-prev-badge');
    if (!badge) return false;
    const count = Number.parseInt(badge.dataset.numberOfReviews || '', 10);
    const average = Number.parseFloat(badge.dataset.averageRating || '');
    const hasVerifiedData = Number.isFinite(count) && Number.isFinite(average);
    const ratingLabel = hasVerifiedData
      ? `Calificado ${average.toLocaleString('es-CO', { maximumFractionDigits: 2 })} basado en ${count.toLocaleString('es-CO')} ${count === 1 ? 'reseña' : 'reseñas'}`
      : badge.innerText.trim();
    if (!ratingLabel) return false;
    const signature = `${average}|${count}|${ratingLabel}`;
    if (host.dataset.lp017RatingSignature === signature) return true;

    const link = document.createElement('a');
    link.href = '#judgeme_product_reviews';
    link.setAttribute('aria-label', ratingLabel);
    const clonedBadge = badge.cloneNode(true);
    const clonedText = clonedBadge.querySelector('.jdgm-prev-badge__text');
    if (clonedText && hasVerifiedData) clonedText.textContent = ratingLabel;
    link.appendChild(clonedBadge);
    host.replaceChildren(link);
    host.dataset.lp017RatingSignature = signature;
    host.dataset.lp017RatingReady = 'true';
    return true;
  }

  function mountJudgeMeReviews() {
    const host = document.querySelector('[data-lp017-reviews]');
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!host || !widget) return false;
    if (host.contains(widget)) return true;
    if (!widget.classList.contains('jdgm--done-setup-widget')) return false;

    const sourceSection = widget.closest('.shopify-section');
    host.replaceChildren(widget);
    host.dataset.lp017ReviewsReady = 'true';
    if (sourceSection && sourceSection !== host.closest('.shopify-section')) {
      sourceSection.classList.add('lp017-review-source-empty');
    }
    return true;
  }

  function activateNativeBridge() {
    const productInfo = document.querySelector('product-info[data-product-id="8269480001583"]');
    const section = productInfo && productInfo.closest('.shopify-section');
    if (!section) return false;
    section.classList.add('lp017-native-bridge');
    return true;
  }

  function nativeProductArea() {
    return document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
  }

  function openOrder(event) {
    event.preventDefault();
    const target = ensureReleasitButton();
    if (target) {
      target.click();
      return;
    }
    const form = nativeProductArea();
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      form.classList.add('lp017-order-focus');
      window.setTimeout(() => form.classList.remove('lp017-order-focus'), 1800);
    }
  }

  document.querySelectorAll(selector).forEach(button => {
    if (button.dataset.lp017Bound === 'true') return;
    button.dataset.lp017Bound = 'true';
    button.addEventListener('click', openOrder);
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionVideos = [...document.querySelectorAll('[data-lp017-motion]')];
  function syncMotionPreference() {
    motionVideos.forEach(video => {
      if (reducedMotion.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        video.currentTime = 0;
        video.controls = true;
      } else {
        video.controls = false;
        video.muted = true;
        video.play().catch(() => {});
      }
    });
  }
  syncMotionPreference();
  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', syncMotionPreference);
  }

  // Releasit and Judge.me can finish after the theme section.
  // Poll for at most 15 seconds, then stop permanently.
  let integrationAttempts = 0;
  const integrationTimer = window.setInterval(() => {
    integrationAttempts += 1;
    const releasitReady = Boolean(ensureReleasitButton());
    const judgeMeReady = syncJudgeMeRating();
    const reviewsReady = mountJudgeMeReviews();
    if ((releasitReady && judgeMeReady && reviewsReady && activateNativeBridge()) || integrationAttempts >= 20) {
      window.clearInterval(integrationTimer);
    }
  }, 750);

  const hero = document.getElementById('lp017-hero');
  const sticky = document.querySelector('[data-lp017-sticky]');
  if (hero && sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      const passedHero = entries[0] && !entries[0].isIntersecting && window.scrollY > hero.offsetHeight / 2;
      sticky.classList.toggle('is-visible', passedHero);
    }, { threshold: 0 });
    observer.observe(hero);
  }
})();
